'use client';

import type { User } from '@sentry/react';
import { useEffect, type PropsWithChildren } from 'react';

type SetUserFn = (user: User | null) => void;

export function createMonitoringProvider(setUser: SetUserFn) {
  return ({ children, user }: PropsWithChildren<{ user?: { id: string; email?: string } }>) => {
    useEffect(() => {
      if (user != null) {
        setUser(user);
      } else {
        setUser(null);
      }
    }, [user?.id]);

    return children;
  };
}
